/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'semantic-ui-react';
import { saveLocationAC } from '../../action-creators';
import { setInitialValues } from './utils/form-utils';
import { Field, Formik } from 'formik';
import { InputField, Label } from './fields';
import { ActionsSection } from './buttons/actions-section';
import { GeoSuggest } from '../widgets/geo-suggest';

const FIELDS = [
  'country',
  'streetNumber',
  'premise',
  'route',
  'locality',
  'postalTown',
  'administrativeAreaLevel1',
  'administrativeAreaLevel2',
  'placeId',
  'formattedAddress',
  'gps',
  'name'
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function setGeoValue(propName: any, result: any, setFieldValue: any) {
  setFieldValue(propName, result[propName]);
}

function handleGeoSuggestChange(result: any, setFieldValue: any) {
  const setValue = (propName: any) => setFieldValue(propName, result[propName]);
  setValue('country');
  setValue('streetNumber');
  setValue('route');
  setValue('locality');
  setValue('postalTown');
  setValue('administrativeAreaLevel1');
  setValue('administrativeAreaLevel2');
  setValue('placeId');
  setValue('formattedAddress');
  setValue('gps');
}

function LocationForm(props: any) {
  const { dispatch, onClose } = props;
  const boundHandleSubmit = (values: any, formikActions: any) =>
    dispatch(saveLocationAC({ data: values, formikActions, closeDialog: onClose }));
  return (
    <Formik initialValues={setInitialValues(FIELDS, props)} onSubmit={boundHandleSubmit}>
      {({ values, handleSubmit, isSubmitting, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <div className="inline field">
            <Label>Enter location:</Label>
            <div className="ui input">
              <GeoSuggest onChange={(e: any, data: any) => handleGeoSuggestChange(data, setFieldValue)} />
              <address>{values.formattedAddress}</address>
            </div>
          </div>
          <Field name="name" label="Name" component={InputField} />
          <ActionsSection isNew={!values.id} disabled={isSubmitting} onCancel={props.onClose} />
        </Form>
      )}
    </Formik>
  );
}

const ConnectedComponent = connect((state: any) => ({
  app: state.app,
  serviceProviders: state.serviceProviders
}))(LocationForm);

export default ConnectedComponent;
